const HEX_REGEX = /^#([0-9a-f]{3}|[0-9a-f]{6})$/i;

const expandHex = (value) => {
  if (!value) return null;
  const normalized = value.replace("#", "");
  if (normalized.length === 3) {
    return normalized
      .split("")
      .map((char) => char + char)
      .join("");
  }
  if (normalized.length === 6) {
    return normalized;
  }
  return null;
};

export const applyAlpha = (color, alpha) => {
  if (typeof color !== "string") return color;
  if (!HEX_REGEX.test(color)) return color;
  const expanded = expandHex(color);
  if (!expanded) return color;
  const numeric = parseInt(expanded, 16);
  const r = (numeric >> 16) & 255;
  const g = (numeric >> 8) & 255;
  const b = numeric & 255;
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};

export const buildLinearGradient = (stops, angle = 135) => {
  if (!Array.isArray(stops) || stops.length === 0) return null;
  return `linear-gradient(${angle}deg, ${stops.join(", ")})`;
};

export const humanizeToken = (value) => {
  if (!value || typeof value !== "string") return value;
  const normalized = value.replace(/[_-]+/g, " ").replace(/\s+/g, " ").trim();
  if (!normalized) return value;
  return normalized.charAt(0).toUpperCase() + normalized.slice(1);
};

export const hexToRgb = (value) => {
  if (typeof value !== "string" || !HEX_REGEX.test(value)) return null;
  const expanded = expandHex(value);
  if (!expanded) return null;
  return {
    r: parseInt(expanded.slice(0, 2), 16),
    g: parseInt(expanded.slice(2, 4), 16),
    b: parseInt(expanded.slice(4, 6), 16),
  };
};

const linearize = (channel) => {
  const c = channel / 255;
  return c <= 0.03928 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4);
};

export const getRelativeLuminance = (color) => {
  const rgb = hexToRgb(color);
  if (!rgb) return null;
  const r = linearize(rgb.r);
  const g = linearize(rgb.g);
  const b = linearize(rgb.b);
  return 0.2126 * r + 0.7152 * g + 0.0722 * b;
};

export const isDarkColor = (color, threshold = 0.4) => {
  const luminance = getRelativeLuminance(color);
  if (luminance == null) return false;
  return luminance < threshold;
};

